import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {ProcedurePageContext} from 'procedures/ProcedurePageContext';
import {GRAY_DARKER, GRAY_LIGHT, hexToRgba} from 'ui-library/Colors';

import {
  getMethodNameOrPlaceholder,
  methodBodyClass,
  nodeNameBoxClass,
  nodeNameTextEllipsesClass,
  makePlaceholderNameClass,
  subSectionClass,
  nodeWrapperStyle,
} from '../procedureMethodNodeCommonConsts';

export default function ProcedureMethodBeingDraggedNodeRenderer(props: {
  name: string;
  position: {x: number; y: number};
  zoom: number;
  isIntersectingDropZone: boolean;
}): JSX.Element {
  const {procedureMetadata} = ProcedurePageContext.useContext();
  const procedureType = procedureMetadata.procedureType;

  // Hardcoding false since dragging method will never have validation errors
  const nodeNameBoxClassName = nodeNameBoxClass(false, props.isIntersectingDropZone);
  const methodBodyClassName = methodBodyClass(false, props.isIntersectingDropZone);
  const grayBoxClass = css(styles.grayBox);

  const subSectionDiv = (
    <div className={subSectionClass}>
      <div className={grayBoxClass} />
    </div>
  );
  return (
    <div
      className={css(nodeWrapperStyle, styles.shadow)}
      {...getTestProps({component: 'ProcedureMethodBeingDraggedNodeRenderer', element: 'root'})}
      style={{
        top: props.position.y,
        left: props.position.x,
        position: 'absolute',
        transformOrigin: 'top left',
        transform: `scale(${props.zoom}) translate(-50%, -50%)`,
      }}
    >
      <div className={nodeNameBoxClassName}>
        <div className={classNames(nodeNameTextEllipsesClass, makePlaceholderNameClass(props.name))}>
          {getMethodNameOrPlaceholder(props.name, procedureType)}
        </div>
      </div>
      <div className={methodBodyClassName}>
        {subSectionDiv}
        {subSectionDiv}
        {subSectionDiv}
        {subSectionDiv}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  grayBox: {
    width: '100px',
    height: '16px',
    background: GRAY_LIGHT,
    margin: '4px 8px',
  },
  shadow: {
    boxShadow: `0px 2px 6px 0px rgba(${hexToRgba(GRAY_DARKER, 0.7)})`,
  },
});
